export default "__VITE_ASSET__DQjSJvET__"